const cookies = {
  
  /**
   * Set a cookie with name, value and optional days until expiration.
   * @param {string} name name of the cookie
   * @param {string} value vlue of the cookie
   * @param {number} [days] optional, days until expiration, if left empty cookie will expire when browser is closed
   */  
  setCookie: function (name, value, days) {
    let expires;
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  },

  /**
   * Get a cookie by name
   * @param {string} name name of the cookie
   * @returns {string} value of the cookie
   */
  getCookie: function (name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  /**
   * Erase a cookie by name
   * @param {string} name name of the cookie
   */
  eraseCookie: function (name) {
    this.setCookie(name, '', -1);
  }
};

export default cookies;
